import Validator from '../validator';

const BindRequestValidator = new Validator([
  {
    field: 'effDate',
    method: 'isEmpty',
    validWhen: false,
    message:
      'Requested policy effective date must be selected to submit a bind request.',
  },
]);

export default BindRequestValidator;
